export default {
  pagesHomeTitle: '你好',
  minUserInfo: {
    name1: '用户头像',
    name2: '用户账号',
    name3: '用户姓名',
    name4: '用户昵称',
    message1: '只能上传jpg/png/gif用户头像',
    message2: '用户信息更新成功'
  },
  topComponent: {
    message: '请输入搜索内容',
    message1: '密码修改成功，请重新登录',
    tips: '真的要退出登录吗',
    tips1: '确定要清除缓存吗？',
    title1: '修改密码',
    title2: '旧密码',
    title3: '新密码',
    title4: '确认密码',
    title5: '个人中心',
    title6: '退出',
    title7: '清除缓存',
    error1: '请填写密码',
    error2: '请输入16~32位字母或数字组合',
    error3: '新密码和确认密码输入不一致',
    btn1: '关闭其他',
    btn2: '关闭所有',
    btn3: '更多'
  },
  navComponent: {
    title: '管理后台',
  },
  pagesHome: {
    select1: '平台',
    select2: '游戏排行',
    title1: '系统平台公告',
    title2: '游戏',
    title3: '注单笔数',
    title4: '投注金额',
    title5: '全部',
    title6: '投注数量',
    title7: '投注人数',
    title8: '金额',
    title9: '人数',
    title10: '游戏注单分布',
    title11: '时间',
    title12: '标题',
    title13: '内容',
    title14: '操作',
    title15: '平台盈亏金额',
    title16: '注单人数',
    title17: '投注金额',
    title18: '中奖人数',
    title19: '实际投注金额',
    title20: '平台数据每隔5分钟刷新',
    title21: '总奖金抽水',
    title22: '活动抽水',
    title23: '访问游戏人数',
    title24: '新增注册人数',
    title25: '今日订单数',
    title26: '订单平均投注金额',
    btn1: '详情',
    btn2: '更多',
    placeholder1: '请选择',
    tips1: '平台盈亏= 有效投注金额 - 中奖金额 +奖金抽水- 返佣-退水-返水-活动金额',
    tips2: '投注金额及实际投注金额(投注金额-退还金额)的实时数据',
    tips3: '奖金抽水= 中奖金额x游戏的奖金抽水',
    tips4: '注单人数/中奖人数统计实时数据',
    tips5: '订单数量统计实时数据，订单平均投注金额=投注金额 / 订单数量',
    tips6: '用于中奖金额实时数据',
    tips7: '返水=投注金额x（平台返点-用户返点）,当平台返点大于游戏返点时，使用游戏返点',
    tips8: '退水=投注金额x用户返点,当用户返点大于游戏返点时，使用游戏返点',
    tips9: '访问游戏人数统计实际登录游戏用户数量',
    tips10: '用户领取的活动金额',
    date1: '今日',
    date2: '昨日',
    date3: '近7天',
    date4: '近30天',
  }
}
